import React, { Component, Fragment } from 'react';
import axios from 'axios';
import {Link} from 'react-router-dom';
import Album from './Album';
import AlbumsForm from '../mixins/AlbumsForm';
import ReactGallery from 'react-photo-gallery';

export default class Albums extends Component {
    constructor(props){
        super(props);
        this.state = {
            albums : []
        };

        this.getAlbumCollection = this.getAlbumCollection.bind(this);
    }

    async getAlbumCollection() {
        await axios.get('/album-collection')
            .then(res => {
                this.setState({
                    albums: res.data
                })
            })
            .catch(e => console.log(e));
    }

    async componentDidMount(){
        await this.getAlbumCollection();
    }

    async submitForm(id, e) {
        e.preventDefault();
        await axios.post(`album/${id}/delete`)
                .then(res => {
                    this.getAlbumCollection();
                    this.props.history.push('/');
                }).catch(e => console.log(e));
    }
    render() {

        let albums = this.state.albums.map(album => {
            return {
                uri : album.uri,
                width : album.width,
                height : album.height,
                id :  album.id,
                title: album.title,
                description: album.description,
                alt: album.title
            }
        });

        return (
                <div className="container">
                    {albums.length <= 0 ?
                        <div className="no-images">
                            <h5 className="text-center">
                                You currently have no album.
                                <Link to="/album/create">Create one now</Link>
                            </h5>
                        </div>
                        :
                        <div className="row">
                            {albums.map(album => {
                                return (
                                    <Fragment key={album.id}>
                                        <Album album={album} getAlbums={this.getAlbumCollection}/>
                                        {user.admin ?
                                            <form onSubmit={this.submitForm.bind(this, album.id)} method="POST">
                                                <button className="btn btn-danger">Delete</button>
                                            </form>
                                        : null}
                                    </Fragment>
                                )
                            })}
                        </div>
                    }
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/Albums.js